"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const metric_1 = require("./metric");
var MerchMetric;
(function (MerchMetric) {
    MerchMetric["AddToCartCount"] = "addToCartCount";
    MerchMetric["AddToCartRate"] = "addToCartRate";
    MerchMetric["RevenueSum"] = "revenueSum";
    MerchMetric["UniqueUsers"] = "uniqueUsers";
    MerchMetric["UnitSoldCount"] = "unitSoldCount";
    MerchMetric["ViewAverage"] = "viewAverage";
    MerchMetric["ViewCount"] = "viewCount";
    MerchMetric["VisitCount"] = "visitCount";
})(MerchMetric || (MerchMetric = {}));
exports.MerchandisingMetric = Object.assign(Object.assign({}, MerchMetric), metric_1.Metric);
//# sourceMappingURL=merchandising.metric.js.map